<template>
    <div class="second_step-container">
        <h1>{{translate("select_fan_sort")}}</h1>
        <div class="elements-container">

            <second-step-element v-for="element in getSecondStepElements"
                                 :id="element.id"
                                 :key="element.id"
                                 :name="element.title_translation_code"
                                 :img-src="element.imgSrc"
                                 :multiple_fans="element.multiple_fans">
            </second-step-element>
        </div>
    </div>
</template>

<script>
    import SecondStepElement from '@/components/configuration_steps/secondStep/SecondStepElement.vue'

    export default {
        name: "SecondStep",
        components: {SecondStepElement},
        computed: {

            getSecondStepElements() {
                return this.$store.state.secondStepElements;
            }
        },
        methods: {
            changeStep(step) {

                this.$store.commit({
                    type: 'changeActiveConfigurationStep',
                    step: step
                })
            },
            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;

            },
            loadElements() {
                this.$store.commit('loadSecondStepData');

                if (this.$store.state.secondStepElements.length < 2) {
                    let defaultId = -1;

                    if(this.$store.state.secondStepElements.length == 1 && this.$store.state.secondStepElements[0].id)
                        defaultId = this.$store.state.secondStepElements[0].id;

                    this.selectDefaultElement(defaultId);
                }
            },
            selectDefaultElement(id, name, imgSrc, multiple_fans) {

                this.$store.commit({
                    type: 'selectSecondStepElement',
                    id: id,
                    name: name,
                    imgSrc: imgSrc,
                    multiple_fans: multiple_fans,
                });

                this.changeStep(3);
            },
        },
        beforeMount() {
            //TODO: jeżeli się zmienił krok, to totaj czyścimy  this.$store.state.secondStepElements = [];
            this.$store.state.secondStepElements = [];
            this.loadElements();
        }
    }
</script>